export const ChatLoading = () => {
  return (
    <div className="mx-24 flex w-auto flex-col gap-4 pt-4 pb-8 lg:mx-10">
      <div className="animate-pulse">
        <div className="flex items-start gap-3 pt-4">
          <div className="flex min-w-0 flex-1 flex-col items-end gap-2">
            <div className="h-3 w-16 rounded bg-system-white08" />
            <div className="max-w-[90%] rounded-tl-16 rounded-tr-8 rounded-br-16 rounded-bl-8 bg-[rgba(87,101,242,0.16)] px-4 py-3">
              <div className="space-y-2">
                <div className="h-3 w-72 max-w-[55vw] rounded bg-system-white24" />
                <div className="h-3 w-44 max-w-[35vw] rounded bg-system-white24" />
              </div>
            </div>
            <div className="h-3 w-24 rounded bg-system-white08" />
          </div>
          <div className="size-8 shrink-0 rounded-full bg-system-white12" />
        </div>
      </div>

      <div className="animate-pulse">
        <div className="flex items-start gap-3 pt-4">
          <div className="size-8 shrink-0 rounded-full bg-system-white12" />
          <div className="min-w-0 flex-1">
            <div className="mb-2 h-3 w-20 rounded bg-system-white12" />
            <div className="space-y-2">
              <div className="h-3 w-11/12 rounded bg-system-white12" />
              <div className="h-3 w-4/5 rounded bg-system-white12" />
              <div className="h-3 w-2/3 rounded bg-system-white12" />
            </div>
            <div className="mt-3 h-3 w-32 rounded bg-system-white08" />
          </div>
        </div>
      </div>

      <div className="animate-pulse">
        <div className="flex items-start gap-3 pt-4">
          <div className="flex min-w-0 flex-1 flex-col items-end gap-2">
            <div className="h-3 w-16 rounded bg-system-white08" />
            <div className="max-w-[90%] rounded-tl-16 rounded-tr-8 rounded-br-16 rounded-bl-8 bg-[rgba(87,101,242,0.16)] px-4 py-3">
              <div className="space-y-2">
                <div className="h-3 w-72 max-w-[55vw] rounded bg-system-white24" />
                <div className="h-3 w-44 max-w-[35vw] rounded bg-system-white24" />
              </div>
            </div>
            <div className="h-3 w-24 rounded bg-system-white08" />
          </div>
          <div className="size-8 shrink-0 rounded-full bg-system-white12" />
        </div>
      </div>

      <div className="animate-pulse">
        <div className="flex items-start gap-3 pt-4">
          <div className="size-8 shrink-0 rounded-full bg-system-white12" />
          <div className="min-w-0 flex-1">
            <div className="mb-2 h-3 w-20 rounded bg-system-white12" />
            <div className="space-y-2">
              <div className="h-3 w-10/12 rounded bg-system-white12" />
              <div className="h-3 w-11/12 rounded bg-system-white12" />
              <div className="h-3 w-3/5 rounded bg-system-white12" />
            </div>
            <div className="mt-3 h-3 w-28 rounded bg-system-white08" />
          </div>
        </div>
      </div>
    </div>
  );
};
